import React from 'react'

interface ProgressCircleProps {
  percentage: number
  size?: number
}

export const ProgressCircle: React.FC<ProgressCircleProps> = ({ percentage, size = 48 }) => {
  const progressColor = percentage === 100 ? 'var(--zocks-success)' : percentage > 0 ? 'var(--zocks-primary)' : 'var(--zocks-gray-600)'

  const radius = 20
  const strokeWidth = 4
  const circumference = 2 * Math.PI * radius
  const center = 24

  return (
    <div className='position-relative d-flex align-items-center justify-content-center' style={{ width: `${size}px`, height: `${size}px` }}>
      <svg width={size} height={size} viewBox={`0 0 48 48`} className='position-absolute top-0 start-0'>
        <circle cx={center} cy={center} r={radius} fill='none' stroke='var(--zocks-gray-200)' strokeWidth={strokeWidth} />
        <circle
          cx={center}
          cy={center}
          r={radius}
          fill='none'
          stroke={progressColor}
          strokeWidth={strokeWidth}
          strokeDasharray={`${(percentage / 100) * circumference} ${circumference}`}
          strokeLinecap='round'
          transform={`rotate(-90 ${center} ${center})`}
        />
      </svg>
      <span className='fw-bold zocks-text-gray-700 text-center position-relative paragraph-extra-small z-1'>{percentage}%</span>
    </div>
  )
}
